<h1>blogs works!</h1>
<app-blogs-detail></app-blogs-detail>
